import { useCallback } from 'react'
import { Modal } from 'antd-mobile'
import i18n from '@/i18n'

export function useHanlde() {
  /**
   * cash on delivery 权益不足提示
   */
  const SellerToBuyCashOnDeliveryCountConfirm = useCallback(() => {
    Modal.alert({
      content: i18n.t('setting.h5deduct.confirm'),
      confirmText: i18n.t('common.Ikonw'),
    })
  }, [])

  return {
    SellerToBuyCashOnDeliveryCountConfirm,
  }
}
